import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    checkboxRoot: {
      border: "1px solid #333",
      width: 34,
      height: 34,
      color: primary.dark
    },
    checkboxIcon: {
      color: primary.dark,
      "&.checked": {
        color: primary.main
      }
    },
    approved: {
      backgroundColor: secondary.dark,
      "&.Mui-checked:hover": {
        backgroundColor: secondary.dark,
        borderColor: "#004c39"
      }
    },
    denied: {
      backgroundColor: "#d82f44",
      "&.Mui-checked:hover": {
        backgroundColor: "#d82f44",
        borderColor: "#60131d"
      }
    }
  };
});
